import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DatePickerModule } from 'primeng/datepicker';

import { AngularMyDatePickerModule } from '../common/legacy-lib/angular-mydatepicker/angular-mydatepicker.module';
import { TextMaskModule } from '../common/legacy-lib/text-mask';
import { FmDatePickerComponent } from '../fannie-mae-cdx-components/fm-date-picker/fm-date-picker.component';
import { FmProgressBarComponent } from '../fannie-mae-cdx-components/fm-progress-bar/fm-progress-bar.component';
import { FmDatePickerMegaComponent } from '../mega-exchange/fm-date-picker-mega/fm-date-picker-mega.component';
import { FeeScheduleComponent } from '../rcr-exchange/fee-schedule/fee-schedule.component';
import { CalendarPickerComponent } from './calendar-picker/calendar-picker.component';
import { ServerErrorComponent } from './components/errors/server-error/server-error.component';
import { AvoidSpecialCharDirective } from './directives/avoid-special-char.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { FooterButtonComponent } from './footer-button/footer-button.component';

@NgModule({
  imports: [
    AngularMyDatePickerModule,
    DatePickerModule,
    CommonModule,
    FormsModule,
    RouterModule,
    TextMaskModule,
    FmProgressBarComponent,
    FeeScheduleComponent,
  ],
  declarations: [
    AvoidSpecialCharDirective,
    FmDatePickerComponent,
    CalendarPickerComponent,
    FmDatePickerMegaComponent,
    NumberOnlyDirective,
    ServerErrorComponent,
    FooterButtonComponent,
  ],
  exports: [
    AvoidSpecialCharDirective,
    CommonModule,
    FmDatePickerComponent,
    FmDatePickerMegaComponent,
    FmProgressBarComponent,
    NumberOnlyDirective,
    RouterModule,
    CalendarPickerComponent,
    TextMaskModule,
    FooterButtonComponent,
    FeeScheduleComponent,
  ],
})
export class SharedModule {}
